export default __webpack_public_path__ + "static/media/backgroundCont.b99b3bd3.jpg";